import logo from './logo.svg';
import './App.css';

// Components
import LandingPage from './pages/Home'
import "bootstrap/dist/css/bootstrap.min.css";
function App() {
  return (
    <LandingPage />
  );
}

export default App;
